export class Court {
    id!: number;
    name!: string;
    address1!: string;
    address2!: string;
    city!: string;
    state!: IState;
    zip!: string;
    approved?: boolean;
    isPublic?:boolean;
    isClub?:boolean;
    hasIndoor?:boolean;
    numberOfCourt!: number | null;
    sport!: ISport;
}

export interface IState {
    id: number;
    code: string;
    name: string;
}
export interface ISport {
    id: number;
    name: string;
  }